import { Pipe, PipeTransform } from '@angular/core';
import { Constants } from '@core/globals/constants';

@Pipe({
  name: 'nyja',
})
export class NyjaPipe implements PipeTransform {
  transform(value: number | undefined, type: string = 'short'): string {
    if (!value) {
      return '';
    }
    if (type == 'long') return Constants.Nyja.find((p) => p.id == value)!.long;
    return Constants.Nyja.find((p) => p.id == value)!.short;
  }
}
